import { useTradeWasteContext } from "../../tradeWasteContext";


export default function SharedGreaseArrestorApplication() {
  const [tradeWasteContext] = useTradeWasteContext()

  return (
    <p>
      An online application is currently not available for your selection.
      Please{" "}
      <a
        href={tradeWasteContext.sharedGreaseFormUrl}
        target="_blank"
        rel="noopener noreferrer"
      >
        download and complete this form
      </a>{" "}
      and email it to{" "}
      <a href={`mailto:${tradeWasteContext.emailAddress}`}>
        {tradeWasteContext.emailAddress}
      </a>
    </p>
  );
}
